import { Record, Map, List } from 'immutable';
import { ADSTATE_CONTAINERS } from 'SharedConstants/';

export default class LayoutRecord extends Record({
  key: '',
  id: 0,
  name: '',
  device: '',
  inApp: false,
  deviceHeader: 40,
  background: '',
  backgroundFileName: '',
  backgroundAlign: '',
  backgroundEfffect: '',
  backgroundMonochrome: false,
  backgroundOpacity: '',
  backgroundDimensions: Map({ width: 0, height: 0 }),
  adStateContainers: List(),
  isCustom: false,
  hasChanged: false,
}) {
  adStateContainersList(preview) {
    const adStateFromState = preview.getIn([ADSTATE_CONTAINERS, this.key]);
    return adStateFromState.adStateContainers
      .map(c => preview.getIn([ADSTATE_CONTAINERS, c]).toList(preview))
      .flatten(true);
  }

  getAdStateContainers(preview) {
    const adStateContainers = preview.getIn([ADSTATE_CONTAINERS]);
    return this.adStateContainers.map(previewId => adStateContainers.get(previewId));
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/records/LayoutRecord.js